import type { CSSProperties } from 'react';

// FontAwesome icon map ported 1:1 from the prototype.
export const FA_MAP: Record<string, string> = {
  home: 'fa-solid fa-house',
  warehouse: 'fa-solid fa-warehouse',
  users: 'fa-solid fa-users',
  sliders: 'fa-solid fa-sliders',
  forecast: 'fa-solid fa-chart-line',
  plan: 'fa-solid fa-list-check',
  hiring: 'fa-solid fa-user-plus',
  upload: 'fa-solid fa-file-arrow-up',
  audit: 'fa-solid fa-clipboard-check',
  search: 'fa-solid fa-magnifying-glass',
  command: 'fa-solid fa-square-caret-up',
  bell: 'fa-regular fa-bell',
  user: 'fa-regular fa-circle-user',
  logout: 'fa-solid fa-right-from-bracket',
  globe: 'fa-solid fa-globe',
  building: 'fa-solid fa-building',
  grid: 'fa-solid fa-bars',
  'chevron-down': 'fa-solid fa-chevron-down',
  'chevron-right': 'fa-solid fa-chevron-right',
  'chevron-left': 'fa-solid fa-chevron-left',
  check: 'fa-solid fa-check',
  x: 'fa-solid fa-xmark',
  plus: 'fa-solid fa-plus',
  minus: 'fa-solid fa-minus',
  edit: 'fa-regular fa-pen-to-square',
  trash: 'fa-regular fa-trash-can',
  download: 'fa-solid fa-download',
  print: 'fa-solid fa-print',
  pdf: 'fa-regular fa-file-pdf',
  excel: 'fa-regular fa-file-excel',
  filter: 'fa-solid fa-filter',
  refresh: 'fa-solid fa-rotate',
  rocket: 'fa-solid fa-rocket',
  play: 'fa-solid fa-play',
  pause: 'fa-solid fa-pause',
  info: 'fa-solid fa-circle-info',
  warning: 'fa-solid fa-triangle-exclamation',
  critical: 'fa-solid fa-circle-exclamation',
  spark: 'fa-solid fa-bolt',
  history: 'fa-solid fa-clock-rotate-left',
  ellipsis: 'fa-solid fa-ellipsis',
  diff: 'fa-solid fa-code-branch',
  copy: 'fa-regular fa-copy',
  external: 'fa-solid fa-arrow-up-right-from-square',
  shield: 'fa-solid fa-shield-halved',
  lock: 'fa-solid fa-lock',
  mail: 'fa-regular fa-envelope',
  calendar: 'fa-regular fa-calendar',
  clock: 'fa-regular fa-clock',
  link: 'fa-solid fa-link',
  arrowUp: 'fa-solid fa-arrow-up',
  arrowDown: 'fa-solid fa-arrow-down',
  arrowRight: 'fa-solid fa-arrow-right',
  layers: 'fa-solid fa-layer-group',
  cube: 'fa-solid fa-cube',
  truck: 'fa-solid fa-truck',
  cog: 'fa-solid fa-gear',
  eye: 'fa-regular fa-eye',
  drag: 'fa-solid fa-grip-vertical',
  database: 'fa-solid fa-database',
  help: 'fa-regular fa-circle-question',
  book: 'fa-solid fa-book-open',
};

export type IconName = keyof typeof FA_MAP | string;

interface IconProps {
  name: IconName;
  size?: number;
  style?: CSSProperties;
  className?: string;
  'aria-hidden'?: boolean;
}

export function Icon({ name, size = 14, style, className, ...rest }: IconProps) {
  const cls = FA_MAP[name] ?? 'fa-regular fa-circle';
  return (
    <i
      aria-hidden
      className={(className ? className + ' ' : '') + cls}
      style={{
        fontSize: size,
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size + 2,
        height: size + 2,
        ...style,
      }}
      {...rest}
    />
  );
}
